/* tslint:disable */
/* eslint-disable */
/**
 * Backoffice Microservice
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface IamUserCompaniesList
 */
export interface IamUserCompaniesList {
    /**
     * 
     * @type {string}
     * @memberof IamUserCompaniesList
     */
    id?: string;
    /**
     * 
     * @type {string}
     * @memberof IamUserCompaniesList
     */
    companyTopId?: string;
    /**
     * 
     * @type {string}
     * @memberof IamUserCompaniesList
     */
    shortName?: string;
}

export function IamUserCompaniesListFromJSON(json: any): IamUserCompaniesList {
    return IamUserCompaniesListFromJSONTyped(json, false);
}

export function IamUserCompaniesListFromJSONTyped(json: any, ignoreDiscriminator: boolean): IamUserCompaniesList {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': !exists(json, 'id') ? undefined : json['id'],
        'companyTopId': !exists(json, 'company_top_id') ? undefined : json['company_top_id'],
        'shortName': !exists(json, 'short_name') ? undefined : json['short_name'],
    };
}

export function IamUserCompaniesListToJSON(value?: IamUserCompaniesList | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'company_top_id': value.companyTopId,
        'short_name': value.shortName,
    };
}


